(ns frontend.ui.component.steps-band.view
  (:require
   [frontend.ui.component.steps-band.style :as style]
   [herb.core :refer [<class]]
   [frontend.ui.component.icon.view :refer [icon]]
   [common.localization :as loc]))

(defn step
  [{:keys [idx step-key title icon-id status steps-count activate-step]}]
  [:div
   {:class    (<class style/step status)
    :on-click (fn []
                (when (= status :completed)
                  (activate-step step-key)))}
   [:div
    {:class (<class style/step-icon status)}
    [icon icon-id]]
   [:div
    {:class (<class style/step-content status)}
    [:div
     {:class (<class style/step-number)}
     (loc/tr :step-n-n [(inc idx) steps-count])]
    [:div
     {:class (<class style/step-label status)}
     title
     #_[:span
        {:style {:position "absolute"
                 :top      "0"
                 :left     "0"}}
        (str status)]]]])

(defn step-status
  [active-idx completed-idx step-idx]
  (cond
    (and (>= completed-idx step-idx)
         (= active-idx step-idx))
    :completed-active

    (>= completed-idx step-idx)
    :completed

    (= active-idx step-idx)
    :active

    :else
    :next))

(defn steps-band
  [{:keys [activate-step active-step-key completed-step-key]} sorted-steps]
  (let [steps-count (count sorted-steps)
        active-index (->> sorted-steps
                          (map-indexed (fn [idx step]
                                         (when (= active-step-key (:step-key step))
                                           idx)))
                          (remove nil?)
                          (first))
        completed-index (->> sorted-steps
                             (map-indexed (fn [idx step]
                                            (when (= completed-step-key (:step-key step))
                                              idx)))
                             (remove nil?)
                             (first))]
    (->> sorted-steps
         (map-indexed (fn [idx {:keys [icon-id key title] :as step-meta}]
                        [step
                         (assoc step-meta
                                :idx idx
                                :activate-step activate-step
                                :status (step-status active-index completed-index idx)
                                :steps-count steps-count)]))
         (into [:div {:class (<class style/steps-band)}]))))
